import { FetchDataProvider } from '@hb/react'
import { PropsWithChildren } from 'react'
import { useDocument } from '../../backend/db/hooks/useDocument'
import {
  fetchItem,
  fetchItems,
  subscribeToItem,
  subscribeToQuery,
  updateDocument,
} from '../../backend/db/utils/documents'
import { useBaseQuery } from '../../hooks/backend/useQuery'
import { useQueryCount } from '../../hooks/backend/useQueryCount'

export const WebFetchDataProvider = ({ children }: PropsWithChildren) => (
  <FetchDataProvider
    useDocument={useDocument}
    useQuery={useBaseQuery}
    useQueryCount={useQueryCount}
    subscribeToItem={subscribeToItem}
    subscribeToQuery={subscribeToQuery}
    fetchItem={fetchItem}
    fetchItems={fetchItems}
    updateItem={updateDocument}>
    {children}
  </FetchDataProvider>
)
